import { enhancedApi } from './generated/taskImportRunsService';

export const taskImportRunsApiClient = enhancedApi.enhanceEndpoints({
  endpoints: {
    taskImportRunsList: {
      providesTags: (result) => {
        if (!result || result.length === 0) {
          return [{ type: 'task_import_runs', id: 'LIST' }];
        }
        return [
          { type: 'task_import_runs', id: 'LIST' },
          ...result.map((run) => ({
            type: 'task_import_runs' as const,
            id: String(run.id),
          })),
        ];
      },
    },
    taskImportRunsRetrieve: {
      providesTags: (_result, _error, arg) => [
        { type: 'task_import_runs', id: String(arg.id) },
      ],
    },
    taskImportRunsDetail: {
      providesTags: (_result, _error, arg) => [
        { type: 'task_import_runs', id: `detail:${String(arg.id)}` },
      ],
    },
    taskImportRunsMatterLinks: {
      providesTags: (_result, _error, arg) => [
        { type: 'task_import_runs', id: `matters:${String(arg.id)}` },
      ],
    },
    taskImportRunsTaskLinksForMatter: {
      providesTags: (_result, _error, arg) => [
        {
          type: 'task_import_runs',
          id: `tasks:${String(arg.id)}:${String(arg.matterLinkId)}`,
        },
      ],
    },
    taskImportRunsGuessFirmCms: {
      providesTags: (_result, _error, arg) => [
        { type: 'task_import_runs', id: `guess:${String(arg.firmId)}` },
      ],
    },
    taskImportRunsCreate: {
      invalidatesTags: () => [{ type: 'task_import_runs', id: 'LIST' }],
      query: (queryArg) => {
        const formData = new FormData();
        Object.entries(queryArg.createTaskImportRun).forEach(([key, value]) => {
          formData.append(key, value);
        });

        return {
          url: `/api/task-import-runs/`,
          method: 'POST',
          body: formData,
        };
      },
    },
  },
});
